import { AuthService } from "./AuthService";
import { useGraphqlService } from "./GraphqlService";
import { useSocketService } from "./SocketService";

export const useConvertOrderService = () => {
    const { executeMutation } = useGraphqlService();
    const { getResponseFromConverter, sendMsgToServ} = useSocketService();

    // Central Feeder Config 전송
    const cfc = (value, onOff, machineInfo) => {
        return new Promise((resolve, reject) => {
            const senactKey = String(new Date().getTime());
            const machineID = machineInfo[0].MACHINE_ID;
            const topic = machineInfo[0].MACHINE_TOPIC;

            // CFC 포맷 메시지 구성 후 공백 및 개행 제거
            const msgTemp = `
            {
                "mtype":"CFC",
                "sid":"${machineID}",
                "val": [
                    {
                        "sid":"202401252",
                        "val":"${onOff}",
                        "key":"${senactKey}",
                        "act":1,
                        "pwm": "100",
                        "blower_value": "100",
                        "exit_dir": "1",
                        "dir": "1",
                        "schedules": ${value},
                        "ai_coeff":"null"
                    }
                ]
            }`;
            const msg = msgTemp.replace(/(\s*)/g, "").replace(/(\r\n\t|\n|\r\t)/gm, "");

            let formData = "";
            formData += `MACHINE_ID:"2023101701",`;
            formData += `MSG_CLASS:"SEND",`;
            formData += `MSG_TYPE:"CFC",`;
            formData += `SENSOR_KEY:"${senactKey}",`;
            formData += `MSG :"${msg.replaceAll('"', '\\"')}",`;

            const query = `mutation { insertMachineData(data:{${formData}}) }`;

            executeMutation(query).then(() => {
                getResponseFromConverter(AuthService.getComCd(), senactKey)
                    .then((next) => { console.log(next); resolve(true); })
                    .catch((error) => { console.error(error); reject(false); });

                sendMsgToServ("mqtt", topic, msg);
            });
        });
    };

    return { cfc };
}